import { render } from "./Offers.vue?vue&type=template&id=5c99d3e8"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"
script.render = render

export default script